import { styled } from 'styled-components';

const BaseLayout = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
	margin: 0;
	padding: 16px 0;
	gap: 16px;
`;

export default BaseLayout;
